import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import GHSeparator from "@/components/GHSeparator";
import { mapState } from "vuex";
export default {
  name: 'GHSubGroup',
  components: {
    GHSeparator /* Separator component */
  },
  data() {
    return {
      flashingIconId: null,
      // Added, used to control shake effect
      shakeTimeout: null // Added, used to store setTimeout return value
    };
  },
  computed: {
    ...mapState({
      current_tag: "current_tag",
      current_rhino_version: "current_rhino_version",
      focusIconId: "focusIconId" // 搜索跳转时正在做聚焦动效的图标
    }),
    filteredGroup() {
      return this.group.filter(comp => {
        return comp.rhino_versions.indexOf(this.current_rhino_version) !== -1;
      });
    },
    hasVisibleIcons() {
      return this.filteredGroup.length > 0;
    },
    layoutHeight() {
      // Determine if the actual row count is greater than zero, if not, return '0px', otherwise return the correct height
      return this.hasVisibleIcons ? `${this.rows * 40}px` : '0px';
    }
  },
  props: {
    group: [Object],
    rows: Number,
    selectedIconId: [String, Number],
    // Added: receive selected icon ID
    highlightedIconId: [String, Number] // Added: receive highlighted icon ID
  },
  methods: {
    onClickComp(name_in_url, id) {
      this.$emit("clickComp", name_in_url, id);
      this.stopShake(); // Added, call stop shake method
      this.flashingIconId = id; // Set shake icon ID

      // Added, store setTimeout return value to this.shakeTimeout
      this.shakeTimeout = setTimeout(() => {
        this.flashingIconId = null;
      }, 800);
    },
    stopShake() {
      // Added, immediately stop shake effect
      this.flashingIconId = null;

      // Added, clear timer
      if (this.shakeTimeout) {
        clearTimeout(this.shakeTimeout);
        this.shakeTimeout = null;
      }
    }
  }
};